import { en } from "vuetify/lib/locale";
import wall from "@/assets/lang/pl/wall";
import tasks from "@/assets/lang/pl/tasks";
import groups from "@/assets/lang/pl/groups";
import group from "@/assets/lang/pl/group";
import profile from "@/assets/lang/pl/profile";
import settings from "@/assets/lang/pl/settings";
import userGroups from "@/assets/lang/pl/userGroups";

export default {
	...en,
	paginate: {
		of: "z",
	},
	home: "Strona główna",
	test: "działam",
	layout: {
		quickAccess: "Szybki dostęp",
		managerPanel: "Panel managera",
		menu: {
			community: "Społeczność",
			groups: "Grupy",
			yourGroups: "Twoje grupy",
			requestedGroups: "Prośby o dołączenie",
			group: "Grupa",
			taskList: "Lista zadań",
			notes: "Notatki",
			saved: "Zapisane wpisy",
			problems: "Zgłoszone problemy",
			polls: "Otwarte ankiety",
			abuses: "Zgłoszenia",
			notFound: "Nie znaleziono strony",
			settings: "Ustawienia",
			profile: "Profil",
			notifications: "Powiadomienia",
			post: "Post",
			comment: "Komentarz",
			searchResults: "Wyniki wyszukiwania",
			chats: "Rozmowy",
			chat: "Rozmowa",
			share: "Udostępnij",
			blog: "Czytaj",
			watch: "Oglądaj"
		},
	},
	description: "Opis",
	publish: "Opublikuj",
	cancel: "Anuluj",
	choose: "Wybierz",
	goBack: "Wstecz",
	delete: "Usuń",
	save: "Zapisz",
	saveChanges: "Zapisz zmiany",
	yes: "Tak",
	cannotEdit: "Nie można edytować",
	views: {
		about: {},
		wall: wall,
		tasks: tasks,
		groups: groups,
		group: group,
		userGroups: userGroups,
		profile: profile,
		settings: settings,
	},
	validation: {
		required: "Pole wymagane",
		unique: "Taka wartość już istnieje",
	},
	emojiMart: {
		search: "Znajdź",
		clear: "Wyczyść", // Accessible label on "clear" button
		notfound: "Nie znaleziono",
		skintext: "Wybierz domyślny kolor skóry",
		categories: {
			search: "Wyszukaj",
			recent: "Najczęstsze",
			smileys: "Uśmiech & Emocje",
			people: "Ludzie & Ciało",
			nature: "Zwierzęta & Przyroda",
			foods: "Jedzenie & Picie",
			activity: "Aktywność",
			places: "Podróżowanie & Miejsca",
			objects: "Obiekty",
			symbols: "Symbole",
			flags: "Flagi",
			custom: "Inne",
		},
		categorieslabel: "Kategorie", // Accessible title for the list of categories
		skintones: {
			1: "Default Skin Tone",
			2: "Light Skin Tone",
			3: "Medium-Light Skin Tone",
			4: "Medium Skin Tone",
			5: "Medium-Dark Skin Tone",
			6: "Dark Skin Tone",
		},
	},
	notifications: {
		notifications: "Powiadomienia",
		unread: "Nieprzeczytane powiadomienia",
		read: "Przeczytane powiadomienia",
		all: "Wszystkie powiadomienia",
		allShort: "Wszystkie",
		unreadShort: "Nieprzeczytane",
		noNewNotifications: "Brak nowych powiadomień",
		noNotifications: "Brak powiadomień",
		showAll: "Wyświetl wszystkie powiadomienia",
		settings: "Ustawienia powiadomień",
		markAll: {
			read: "Oznacz wszystko jako przeczytane",
			unread: "Oznacz wszystko jako nieprzeczytane",
		},
		markAsRead: "Oznacz jako przeczytane",
		markAsUnread: "Oznacz jako nieprzeczytane",
		loadMore: "Wczytaj więcej",
		fromNotification: "Z powiadomienia",
		goToUrl: "Przejdź do wpisu",
		delete: "Usuń powiadomienie",
	},
};
